import { observer } from "mobx-react";
import React from "react";
import { Icon } from "~/components/Icon";
import { Pressable } from "~/components/V2/Pressable";
import { BrandText } from "~/components/V2/Text/BrandText";
import { styleConstantsV2 } from "~/style/styleConstantsV2";

interface TabButtonProps {
  title: string;
  onPress: () => void;
  borderTop?: boolean;
  borderBottom?: boolean;
}

export const ListTabButton = observer(function ListTabButton({
  title,
  onPress,
  borderTop = true,
  borderBottom = true,
}: TabButtonProps) {
  return (
    <Pressable
      justifyContentSpaceBetween
      alignItemsCenter
      flexDirectionRow
      padding24
      onPress={onPress}
      style={{
        borderTopWidth: borderTop ? 1 : 0,
        borderTopColor: styleConstantsV2.colorGrey30,
        borderBottomWidth: borderBottom ? 1 : 0,
        borderBottomColor: styleConstantsV2.colorGrey30,
      }}
    >
      <BrandText sizeH3 colorBlack weightBold>
        {title}
      </BrandText>
      <Icon name="chevron-right" color={styleConstantsV2.colorBlack} />
    </Pressable>
  );
});
